import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Home from "./Pages/Home.page";
import Login from "./Pages/Login.page";
import Recorder from "./Pages/Recorder.page.jsx";
import Player from "./Pages/Player.page.jsx";
import Speeches from "./Pages/Speeches.page";
import Evaluation from "./Pages/Evaluation.page.jsx";
import Uploading from "./Pages/Uploading.page.jsx";
import E404 from "./Pages/E404.page.jsx";
import Unauthorized from "./Pages/Unauthorized.page.jsx";
import Profil from "./Pages/Profil.page.jsx";
import Feedback from "./Pages/Feedback.page.jsx";
import pitchEditor from "./Pages/pitchEditor.page.jsx";
import Header from "./Components/Header";
import PrivateRoute from "./Utils/PrivateRoute";
import S3Upload from "./Utils/S3Upload";
import "./styles/App.css";

const App = ({ user, unauthorized }) => {
  return (
    <div className="App">
      <BrowserRouter>
        <div>
          <Header user={user} />
          <Switch>
            {
              unauthorized === true
              ? <Route exact path="/" component={Unauthorized} />
              : <Route exact path="/" component={Home} />
            }
            <Route exact path="/unauthorized" component={Unauthorized} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/login" component={Login} />

            <PrivateRoute
              exact
              path="/profil/account"
              component={Profil}
              user={user}
            />
            <PrivateRoute
              exact
              path="/profil/pitchs"
              component={Profil}
              user={user}
            />
            
            <PrivateRoute
              exact
              path="/uploading"
              component={Uploading}
              user={user}
            />

            <PrivateRoute
              exact
              path="/record"
              component={({ user }) => (
                <S3Upload
                  render={(evaporate) => (
                    <Recorder
                      user={user}
                      upload={(file) => evaporate.add(file)}
                    />
                  )}
                  pending={() => <div>Its preparing ....</div>}
                />
              )}
            />

            <PrivateRoute
              exact
              path="/pitchs/:id"
              component={({ match, user }) => (
                <Player videoId={match.params.id} user={user} />
              )}
            />
            <PrivateRoute
              exact
              path="/pitchs/:id/feedback"
              component={({ match, user }) => (
                <Feedback videoId={match.params.id} user={user} />
              )}
            />
            <PrivateRoute exact path="/pitchs" component={Speeches} />
            <PrivateRoute
              exact
              path="/pitchs/:id/evaluate"
              component={({ match, user }) => (
                <Evaluation videoId={match.params.id} user={user} />
              )}
            />
            <PrivateRoute
              exact
              path="/pitchs/:id/edit"
              component={pitchEditor}
            />

            <Route component={E404} />
          </Switch>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
